export default {
  props: {
    type: {
      type: String,
      default: 'button',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tabIndex: {
      type: Number,
      default: 0,
    },
    eventName: {
      type: String,
      default: 'click',
    },
  },

  methods: {
    handleClick(e) {
      this.$emit(this.eventName, e)
    },
  },
}
